import React from 'react'
import './BoxContainer.scss'

interface IBoxContainer {
    title: string
    children: React.ReactNode
    className?: string
}

function BoxContainer(props: IBoxContainer) {
    const { children, title, className } = props
    return (
        <div className={`box-container ${className}`}>
            <p className="box-container-title">{title}</p>
            {children}
        </div>
    )
}

export default BoxContainer
